import { SelectChangeEvent, Typography } from "@mui/material";
import { useAppSelector } from "app/hooks";
import HolzfinderSelect from "components/inputs/HolzfinderSelect";
import { selectAgentList } from "features/agentList/agentListSlice";
import { UserRoles } from "interfaces/UserRoles";

export function AgentSelect({ agentId, handleUserRoleChange, fieldErrors }: { agentId: string, handleUserRoleChange: (event: SelectChangeEvent<unknown>) => void, fieldErrors: Record<string, string[]> }) {
  const agentList = useAppSelector(selectAgentList);
  const agentListOptions = agentList.map((agent) => ({
    value: agent.id,
    label: `${agent.eldat_reference_id} / ${agent.county.eldat_reference_id} / ${agent.company}`,
  }));
  return <HolzfinderSelect
    sx={{ width: "100%" }}
    id="agent_id"
    label="Agent-ID"
    options={agentListOptions}
    currentValue={agentId || ""}
    defaultValue={UserRoles.Admin}
    onChange={handleUserRoleChange}
    error={!!fieldErrors.agent_id}
    renderValue={(value) => {
      return <Typography>{agentList.find(agent => agent.id === value)?.eldat_reference_id || ""}</Typography>;
    }}
    helperText={fieldErrors.agent_id ? fieldErrors.agent_id.join(", ") : ""} />;
}
